import { z } from 'zod';

export const performanceDashboardBaseParamsSchema = z.object({
  nomModelo: z.string(),
  categoriaId: z.number().int().optional(),
  anoLetivo: z.number().int().optional(),
  redeId: z.string().optional(),
  escolaId: z.number().int().optional(),
  anoEscolarId: z.number().int().optional(),
  turmaId: z.number().int().optional(),
  alunoId: z.number().optional(),
});

export type PerformanceDashboardBaseParams = z.infer<typeof performanceDashboardBaseParamsSchema>;
